export default {
    'export': 'تصدير',
    'export-as-excel': 'تصدير إكسل',
    'print-warehouse-inventory': 'طباعة جرد المستودع',
    'search-by-material-name-or-num': 'بحث عن رقم أو اسم المادة',
    warehouse: 'المستودع',
    'show-main-materials': 'إظهار المواد الرئيسية',
    'only-materials-which-have-balances': 'المواد ذات الأرصدة فقط',
    refresh: 'تحديث',
    cancel: 'إلغاء',
    'total-count': 'العدد الكلي',
    'total-quantity': 'إجمالي المتبقي',
    'sum-input-quantity': 'إجمالي الداخل',
    'sum-output-quantity': 'إجمالي الخارج',
    'warehouse-inventory': 'جرد المستودع',
    'inventory-price': 'سعر الجرد',
    save: 'حفظ',

    warning: 'تنبيه',
    'it-is-not-possible-to-set-main-material-inventory-price': 'لا يمكن تعيين سعر جرد لمادة رئيسية!',

    headers: {
        'material-no': 'رقم المادة',
        'material-name': 'اسم المادة',
        count: 'العدد',
        'unit-size': 'وحدة القياس',
        quantity: 'الكمية المتبقية',
        price: 'السعر',
        'total-amount': 'القيمة',
        'sum-input-quantity': 'الكمية الداخلة',
        'sum-output-quantity': 'الكمية الخارجة'
    },

    'context-menu': {
        'edit-inventory-price': 'تعديل سعر الجرد',
        'material-statement': 'كشف مادة',
    },

    'edit-inventory-price': 'تعديل سعر الجرد',
    'delivered': 'مسلمة',
    'being-deliver': 'قيد التسليم',
    'being-received': 'قيد الاستلام',
    'material-delivery-status': 'حالة تسليم المواد',
    'from-invoice': 'اخر سعر شراء',
    'from-inventory': 'سعر الجرد',
    'normal': 'كاف',
    'below-minimum': 'منخفض',
    'above-maximum': 'مرتفع',
    'quantity-status': 'حالة مخزون المادة'
}